module.exports = __webpack_public_path__ + "static/media/WaveEnergyWorld.5f6ac27e.jpeg";